var map = {
	"./sel-bumen.png": "c7d9",
	"./sel-gangwei.png": "9b4a",
	"./sel-juese.png": "cd7c",
	"./sel-man.png": "0377",
	"./sel-qunzu.png": "bd49",
	"./sel-zhiwei.png": "1480",
	"./sel-zuzhi.png": "87aa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5861";